import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";
import { IGetSDUIFilteredComponentsRequest } from "@faire/web-api/indigofair/data/IGetSDUIFilteredComponentsRequest";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginated/__internal__/useFilterablePaginatedSectionQuery";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useBrowseLayoutQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutQuery/useBrowseLayoutQuery";
import { useCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";

const PAGE_SIZE = 36;

export const HubPagePrefetcher = () => {
  const navigationPath = useCurrentNavigationPath();
  useBrowseLayoutQuery();
  const filterablePaginatedSection = IFilterablePaginatedSection.build({
    get_s_d_u_i_filtered_components: IGetSDUIFilteredComponentsRequest.build({
      page_identifier: { category_page: { navigation_path: navigationPath } },
      pagination_data: { page_number: 1, page_size: PAGE_SIZE },
    }),
    get_s_d_u_i_navigation_tree_request: { navigation_path: navigationPath },
  });
  useFilterablePaginatedSectionQuery(filterablePaginatedSection);
  return null;
};
